/** Bouwt TaskUIProvider-waarde voor InboxPage: selectie en navigatie naar modal. */
import { useMemo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const isInteractiveTarget = (event) =>
  event?.target?.closest?.('.MuiCheckbox-root, input[type="checkbox"], button');

/** @param {object} params @param {string[]} params.selectedTaskIds @param {boolean} params.isMultiSelectActive @param {(taskId: string) => void} params.onToggleInSelection */
export function useInboxViewUiContext({
  selectedTaskIds,
  isMultiSelectActive,
  onToggleInSelection,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToTask = useCallback(
    (taskId, event) => {
      if (isInteractiveTarget(event)) return;
      navigate(`/app/task/${taskId}`, { state: { from: location } });
    },
    [navigate, location],
  );

  return useMemo(
    () => ({
      view: 'today',
      menuSurface: 'organize-inbox',
      indentationType: 'none',
      onStartAddingSubtask: () => {},
      onRebalance: () => {},
      duplicateOrderKeyTaskIds: new Set(),
      selectedTaskIds,
      isMultiSelectActive,
      isListFocused: false,
      onToggleInSelection,
      onSelectSingle: navigateToTask,
      onTaskClick: navigateToTask,
    }),
    [selectedTaskIds, isMultiSelectActive, onToggleInSelection, navigateToTask],
  );
}
